import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { inject, bind } from '../../../../utils/decorators';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import * as ApiTypesBps from '../../../../models/ApiTypesBps2021';
import { Panel, Table, FormControl, InputGroup } from 'react-bootstrap';

@observer
class BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit extends React.Component<{ ziel: ApiTypesBps.IBpsReferenzkraftDrehzahlSchlupfRollensatz; index: number }, {}> {
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;
  @bind @action handleValueChanged(ev: React.FormEvent<FormControl>) {
    this.props.ziel.geschwindigkeit[this.props.index] = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : undefined;
  }
  @computed get imToleranzbereich() {
    const { drehzahlschlupf } = this.store.datensatz;
    const geschwindigkeit = this.props.ziel.geschwindigkeit[this.props.index];
    return (geschwindigkeit && (geschwindigkeit >= drehzahlschlupf.mingeschwindigkeit));
  }
  render() {
    const { geschwindigkeit } = this.props.ziel;
    return (
      <InputGroup>
        <FormControl
          type="number"
          step="0.1"
          readOnly={this.store.readOnly}
          value={(geschwindigkeit[this.props.index] !== undefined && geschwindigkeit[this.props.index] !== null) ? geschwindigkeit[this.props.index] : ''}
          onChange={this.handleValueChanged}
          className={this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
        />
        <InputGroup.Addon>km/h</InputGroup.Addon>
      </InputGroup>
    );
  }
}

@observer
class BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf extends React.Component<{ ziel: ApiTypesBps.IBpsReferenzkraftDrehzahlSchlupfRollensatz }, {}> {
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;
  @bind @action handleValueChanged(ev: React.FormEvent<FormControl>) {
    this.props.ziel.schlupf = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : null;
  }
  @computed get imToleranzbereich() {
    const { drehzahlschlupf } = this.store.datensatz;
    const { schlupf } = this.props.ziel;
    return (schlupf && (schlupf <= drehzahlschlupf.maxschlupf));
  }
  render() {
    const { schlupf } = this.props.ziel;
    return (
      <InputGroup>
        <FormControl
          type="number"
          step="0.1"
          readOnly={this.store.readOnly}
          value={schlupf !== null ? schlupf : ''}
          onChange={this.handleValueChanged}
          className={this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
        />
        <InputGroup.Addon>%</InputGroup.Addon>
      </InputGroup>
    );
  }
}

/**
 * Exportierte Komponente für Eingabe und Validierung Rollendrehzahl und Abschaltschlupf
 */
@observer
export default class BpsReferenzkraftDrehzahlSchlupf extends React.Component<{}, {}> {

  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  render() {
    const { drehzahlschlupf } = this.store.datensatz;
    return (
      <Panel header="Rollendrehzahl und Abschaltschlupf" collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-drehzahl-schlupf">
          <thead>
            <tr>
                <th/>
                <th>Rolle links</th>
                <th>Rolle rechts</th>
                <th/>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="beschriftung">Geschw. vor Abbrems.</td>
              <td className="messwert">
                <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit ziel={drehzahlschlupf.links} index={0}/>
              </td>
              <td className="messwert">
                <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit ziel={drehzahlschlupf.rechts} index={0}/>
              </td>
              <td>&ge; {drehzahlschlupf.mingeschwindigkeit} km/h </td>
            </tr>
            <tr>
              <td className="beschriftung">Geschw. nach Abbrems.</td>
              <td className="messwert">
                <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit ziel={drehzahlschlupf.links} index={1}/>
              </td>
              <td className="messwert">
                <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupfGeschwindigkeit ziel={drehzahlschlupf.rechts} index={1}/>
              </td>
              <td>&ge; {drehzahlschlupf.mingeschwindigkeit} km/h </td>
            </tr>
            <tr>
              <td className="beschriftung">Abschaltschlupf</td>
              <td className="messwert">
                <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf  ziel={drehzahlschlupf.links}/>
              </td>
              <td className="messwert">
                <BpsReferenzkraftDrehzahlSchlupfMesspunktSchlupf  ziel={drehzahlschlupf.rechts}/>
              </td>
              <td>&le; {drehzahlschlupf.maxschlupf} %</td>
            </tr>
          </tbody>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftDrehzahlSchlupf.tsx